import {Box, SkeletonCircle,SkeletonText,  useToast} from '@chakra-ui/react'
import ComponentHeader from '../main/ComponentHeader';
import GruntComponents from '../components';
import LokacijaControl from './LokacijaControl';
import { addLokacija, getLokacije, getLokacije_V2,updateLokacija,deleteLokacija, Lokacija, Toviliste, Odjeljak } from '../../util/apiLokacija';
import { useEffect,useState } from 'react';
import { getGovedaUBoksu } from '../../util/apiGovedo';
import GovedaSelected from '../govedo/GovedaSelected';

export default function Lokacije({onClosePress}) {
  const [lokacijaid, setLokacijaid]=useState(0);
  const [tovilisteid, setTovilisteid]=useState(0);
  const [odjeljakid, setOdjeljakid]=useState(0);
  const [lokacije,setLokacije]=useState([]);
  const [tovilista,setTovilista]=useState([]);
 const [govedaUBoksu,setGovedaUBoksu]=useState([])
  const [odjeljci,setOdjeljci]=useState([]);
  const [isLoadingTovilista,setIsLoadingTovilista]=useState(false);
  const [isLoadingBoksove,setIsLoadingBoksove]=useState(false);
  const [isLoadingGoveda,setIsLoadingGoveda]=useState(false);
  const [refreshdata,setRefreshData]=useState({lokacije:false,tovilista:false,odjeljci:false,resetodjejci:false,resettovilista:false});
  const toast=useToast();


const fetchLokacije=async(lokacijatipid,parentid=0)=>{
  try {
      let res;
      


      if (lokacijatipid>1) {
        res=await getLokacije(lokacijatipid,parentid);  
      } else {
        res=await getLokacije_V2();  
      }
      
      if (res.status===200) {
          if (lokacijatipid===1) {
              setLokacije(res.res);
          } else if (lokacijatipid===2) {
            setTovilista(res.res)
          } else if (lokacijatipid===3) {
            setOdjeljci(res.res)
          }
          
      } else {
          throw new Error(res.message);
      } 
      
  } catch (error) {
      toast({
          title:"Greška kod dohvata podataka.",
          status:"error",
          description:error.message,
          isClosable:true,
          duration:2000,
          position:"top-right",
      });
  } finally {
    setIsLoadingBoksove(false);
    setIsLoadingTovilista(false);
  }
  
}
useEffect(() => {
  
  fetchLokacije(1,0);//punjenje lokacija
  setTovilista([]);
  setOdjeljci([]);
  setGovedaUBoksu([]);
  
}, [lokacijaid,refreshdata.lokacije])

useEffect(() => {
  setIsLoadingTovilista(true);
  fetchLokacije(2,lokacijaid);//punjenje tovilišta
  setTovilista([]);
  setOdjeljci([]);
  setGovedaUBoksu([]);
  /*if (refreshdata.resetodjejci) {
    setOdjeljci([])  
    
  }*/
  
  
}, [lokacijaid,refreshdata.tovilista])

useEffect(() => {
  setIsLoadingBoksove(true);
  fetchLokacije(3,tovilisteid);//punjenje odjeljaka
  
}, [tovilisteid,refreshdata.odjeljci])

useEffect(() => {
  const getData=async()=>{
    try {
      setIsLoadingGoveda(true);
      const _res=await getGovedaUBoksu(odjeljakid)
      if (_res.status===200) {
        setGovedaUBoksu(_res.res);
      }
      else {
        throw new Error(_res.message);
      }
    } catch (error) {
      toast({
        title:"Greška kod dohvata podataka.",
        status:"error",
        description:error.message,
        isClosable:true,
        duration:2500,
        position:"top-right",
    });
    } finally {
      setIsLoadingGoveda(false);
    }
  }

  if (odjeljakid!==0) {
    getData();
  }

}, [odjeljakid,refreshdata.odjeljci])


  const lokacijaSelected=(id)=>{
    setLokacijaid(id);
    setTovilisteid(0);
    setOdjeljakid(0);
  }

  const tovilisteSelected=(id)=>{
    setTovilisteid(id);
    setOdjeljakid(0);
  }

  const odjeljakSelected=(id)=>{
    setOdjeljakid(id);
  }

  const onDeleteData=async(data)=>{
    if (data.id!==0) {
      try {
        const res=await deleteLokacija(data.id);
        if (res.status===200) {
          if (data.lokacijatip==="LOK") {
            setRefreshData({...refreshdata,lokacije:!refreshdata.lokacije})
          } else if (data.lokacijatip==="TOV") {
            setRefreshData({...refreshdata,tovilista:!refreshdata.tovilista,resetodjejci:false})
          } else if (data.lokacijatip==="ODJ") {
            setRefreshData({...refreshdata,odjeljci:!refreshdata.odjeljci})
          }
          toast({
            title:"Podatak obrisan",
            status:"success",
            isClosable:true,
            duration:1500,
            position:"top-right",
        }); 
        } else if (res.status===400) {
          throw new Error(res.res.message);
        }
        else {
          throw new Error(res.message);
        }
        
      } catch (error) {
        toast({
          title:"Greška kod brisanja podataka.",
          status:"error",
          description:error.message,
          isClosable:true,
          duration:2000,
          position:"top-right",
      });
      }
    }
  }

  const onSaveData=async (data)=>{
    try {
      let res;
      if (data.id===0) {//addnew
        res=await addLokacija(data);
      } else {
        res=await updateLokacija(data);
      }
      //let res=await getLokacije(lokacijatipid,parentid);
      if (res.status===200) {
        if (data instanceof Lokacija) {
          setRefreshData({...refreshdata,lokacije:!refreshdata.lokacije})
        } else if (data instanceof Toviliste) {
          setRefreshData({...refreshdata,tovilista:!refreshdata.tovilista,resetodjejci:false})
        } else if (data instanceof Odjeljak) {
          setRefreshData({...refreshdata,odjeljci:!refreshdata.odjeljci})
        }
        toast({
          title:"Podatak spremljen",
          status:"success",
          isClosable:true,
          duration:1500,
          position:"top-right",
      });   
      } else {
          throw new Error(res.message);
      }
      
  } catch (error) {
      toast({
          title:"Greška kod dohvata podataka.",
          status:"error",
          description:error.message,
          isClosable:true,
          duration:2000,
          position:"top-right",
      });
  }
  }

  const getSkeleton=()=>{
    
      return (
        <Box display={'flex'} flexDir={'column'} flex={1}>
            <SkeletonCircle size='10' />
            <SkeletonText mt='4' noOfLines={15} spacing='4' skeletonHeight='4' />
        </Box>
      )
    
  }

  return (
    <Box   h={'100%'} borderColor={'silver'} borderBottomRightRadius={'md'} borderWidth={'0.5px'} display={'flex'} flexDir={'column'} flex={1} overflowY={'auto'}>
        <ComponentHeader onClosePress={onClosePress} component={GruntComponents.Lokacije}/>
        <Box display={'flex'} flexDir={'column'} flex={1} overflowY={'auto'} bg={'gray.50'} p={'0.5rem'}>
          <Box display={'flex'} flexDir={'row'} flex={1} overflowY={'auto'} gap={'0.5rem'}>
            <Box display={'flex'} flexDir={'column'} flex={1} gap={'0.5rem'}>
            
              <Box flexDir={'column'} display={'flex'} flex={1} bg={'white'} borderWidth={'1px'} borderColor={'gray.200'} borderRadius={'md'} boxShadow={'sm'} overflow={'hidden'}>
                <LokacijaControl _selectedid={lokacijaid} onSelectItem={lokacijaSelected} lokacijatip='LOK' width='27vw' height='80vh' data={lokacije} parentid={0} onSave={onSaveData} onDelete={onDeleteData}/>
              </Box>
              <Box flexDir={'column'} display={'flex'} flex={2} overflowY={'auto'} bg={'white'} borderWidth={'1px'} borderColor={'gray.200'} borderRadius={'md'} boxShadow={'sm'}>
                {isLoadingTovilista?getSkeleton():
                  <LokacijaControl _selectedid={tovilisteid} onSelectItem={tovilisteSelected} lokacijatip='TOV' width='27vw' height='80vh'  data={tovilista} parentid={lokacijaid} onSave={onSaveData} onDelete={onDeleteData}/>
                }
              </Box>
            </Box>
            <Box display={'flex'} flexDir={'column'} flex={1}>
              <Box flexDir={'row'} display={'flex'} flex={1} overflowY={'auto'} bg={'white'} borderWidth={'1px'} borderColor={'gray.200'} borderRadius={'md'} boxShadow={'sm'} overflow={'hidden'}>
              {isLoadingBoksove?getSkeleton():
                  <LokacijaControl _selectedid={odjeljakid} onRefreshMe={()=>setRefreshData({...refreshdata,odjeljci:!refreshdata.odjeljci,tovilista:!refreshdata.tovilista,lokacije:!refreshdata.lokacije})} onSelectItem={odjeljakSelected} lokacijatip='ODJ' width='27vw' height='80vh' data={odjeljci} parentid={tovilisteid} onSave={onSaveData} onDelete={onDeleteData}/>    
              }
                </Box>
            </Box>
            <Box display={'flex'} flexDir={'column'} flex={1} bg={'white'} borderWidth={'1px'} borderColor={'gray.200'} borderRadius={'md'} boxShadow={'sm'} overflow={'hidden'}>
              
              <Box h={'25px'} pl={'0.5rem'} pr={'0.5rem'} display={'flex'} alignItems={'center'}  bg={'grunt2.700'} color={'white'} fontSize={'sm'} fontWeight={'semibold'}>
                Goveda u odabranom boksu
              </Box>
              <Box flexDir={'row'} display={'flex'} flex={1} overflowY={'auto'}>
                {isLoadingGoveda?getSkeleton():
                  <GovedaSelected data={govedaUBoksu} columns={[false,true,true,true,true,true,false]} naslovisvisible={false}/>
                }
              </Box>
            </Box>
          </Box>
        </Box>
        
    </Box>
  )
}